import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "DAVID MARTIN",
    text: "We sold our car to Big Boys Motor Club, and the entire experience was smooth and stress-free. The team was very helpful, professional, and easy to deal with throughout the process. Everything was handled efficiently, and communication was clear from start to finish. I would definitely recommend them to anyone looking to sell or buy!",
    rating: 5,
  },
  {
    id: 2,
    name: "SARAH DHILLON",
    text: "Impressed by the financing team at Big Boys Motor Club. Every dealer I went to was not getting me approved. I checked out their brand new 2023 Honda Civic and got approved within 15 Minutes. If you're having problems getting approved for financing, definitely give these guys an opportunity. Well worth it.",
    rating: 5,
  },
  {
    id: 3,
    name: "AMAN BRAR",
    text: "I was having a really tough time with a car loan transfer and trying to remove my co-signer. I went to a few places and kept hitting dead ends, but Big Boys Motor Club honestly came through for me. The staff were super helpful, patient, and made the whole process so much easier than I expected.",
    rating: 5,
  },
];

/**
 * About Section Component
 *
 * Features:
 * - Background image with overlay
 * - Company introduction
 * - Customer testimonials with star ratings
 * - Quote styling
 */
export default function AboutSection() {
  return (
    <section id="about" className="relative py-24 overflow-hidden w-full">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/dealership-exterior.jpg"
          alt="Dealership"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/85 to-black/90" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* About Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="font-serif text-4xl md:text-4xl font-bold text-white mb-4">
            WELCOME TO{" "}
            <span className="text-brand-red">BIG BOYS MOTORCLUB</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-red to-brand-gold mx-auto mb-8 rounded-full" />

          <p className="text-white/80 text-lg max-w-3xl mx-auto leading-relaxed mb-8">
            At Big Boys MotorClub, we believe getting a vehicle should still be
            possible even if you have bad credit, low credit, no credit, or are
            new to Canada. We work with multiple lenders to help customers with
            all kinds of credit situations, and if you have a steady income or
            full-time job, our team will work hard to help you find a financing
            solution that fits your needs and gets you behind the wheel of a
            reliable vehicle.
          </p>

          {/* <motion.a
            href="#about"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 text-white border-2 border-white/30 rounded-full font-semibold hover:bg-white/20 transition-all duration-300"
          >
            READ MORE
            <ArrowRight className="w-5 h-5" />
          </motion.a> */}
        </motion.div>

        {/* Testimonials */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="font-serif text-2xl font-bold text-white text-center mb-12">
            WHAT OUR <span className="text-brand-gold">CUSTOMERS</span> SAY
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="relative"
              >
                <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 h-full">
                  {/* Quote Icon */}
                  <Quote className="w-10 h-10 text-brand-red mb-4 opacity-60" />

                  {/* Rating */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-4 h-4 fill-brand-gold text-brand-gold"
                      />
                    ))}
                  </div>

                  {/* Text */}
                  <p className="text-white/80 leading-relaxed mb-6 text-sm">
                    "{testimonial.text}"
                  </p>

                  {/* Author */}
                  <div className="pt-4 border-t border-white/10">
                    <p className="font-serif font-bold text-white">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
